import styles from "../../styles/StylishBanner.module.css";

const StylishBanner = ({ heading, tagline, number }) => {
    const bannerClass =
        number === 1
            ? styles.bannerOne
            : number === 2
            ? styles.bannerTwo
            : styles.bannerThree;

    return (
        <div className={bannerClass}>
            <div className="font-poppins font-extralight text-5xl text-primary-gold pt-20 text-center">
                {heading}
            </div>
            {tagline && (
                <div className="font-poppins font-extralight text-3xl text-primary-gold pt-4">
                    {tagline}
                </div>
            )}
            <img
                src="/Banner Icon.png"
                alt="banner icon"
                className="pt-5"
                style={{ imageResolution: "from-image", width: '250px'}}
            />
        </div>
    );
};

export default StylishBanner;
